import React from 'react';
import { Phone, Mail, Rotate3d } from 'lucide-react';
import { router } from '@inertiajs/react';
import './FloatingMenu.css';

const FloatingMenu = ({ isVisible, toggleMenu, isMenuOpen, isScrolled }) => {
    const handlePhoneClick = () => {
        window.location.href = 'tel:+13234662411';
    };

    const handleEmailClick = () => {
        window.location.href = 'mailto:info@hrgalla.com';
    };

    return (
        <div className={`floating-menu-wrapper ${isVisible ? 'visible' : ''}`}>
            <div className={`floating-menu-pill ${isScrolled ? 'scrolled' : ''}`}>
                <button className="float-icon-btn expandable virtual-tour-btn" aria-label="Virtual Tour" onClick={() => router.visit('/virtual-tour')}>
                    <Rotate3d size={18} />
                    <span className="contact-text">Virtual Tour</span>
                </button>
                <button className="float-icon-btn expandable" aria-label="Call" onClick={handlePhoneClick}>
                    <Phone size={18} />
                    <span className="contact-text">+1 323-466-2411</span>
                </button>
                <button className="float-icon-btn expandable" aria-label="Email" onClick={handleEmailClick}>
                    <Mail size={18} />
                    <span className="contact-text">info@hrgalla.com</span>
                </button>
                {/* <button className="float-icon-btn text-btn" aria-label="EN">
                    EN
                </button> */}
                <button className={`float-menu-btn ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                    <span className="menu-text">Menu</span>
                    <div className="hamburger-icon">
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default FloatingMenu;
